//数组操作工具类
class ArrayUtil {
    constructor(array = []) {
        this.cloneDeep = (arr = []) => JSON.parse(JSON.stringify(arr));
        this._array = this.cloneDeep(array);
    }

    /**
     * 在末尾增加数组项
     *
     * @param {*} newItem 添加的数组项
     * @return {Array} 操作后的数组 
     */
    add(newItem) {
        return this._array.concat(newItem);
    }

    /**
     * 根据index删除数组项
     *
     * @param {Number} index 删除Item的index
     * @return {Array} 操作后的数组
     */
    remove(index) {
        this._array.splice(index, 1);
        return this._array;
    }

    /**
     * 在指定位置插入数组项
     *
     * @param {Number} index 插入Item的index
     * @param {*} item 插入的数组项
     * @return {Array} 操作后的数组
     */
    insert(index, item) {
        if(Array.isArray(item)) {
            this._array.splice(index, 0, ...item);
        } else {
            this._array.splice(index, 0, item);
        }
        return this._array;
    }

    /**
     * 移动一个数组项到目标位置
     *
     * @param {Number} fromIndex 移动Item的index
     * @param {Number} toIndex 目标Item的index
     * @return {Array} 操作后的数组
     */
    move(fromIndex, toIndex) {
        if(fromIndex === toIndex) {return this._array;}
        const sourceItem = this._array[fromIndex];
        this._array.splice(fromIndex, 1);
        this._array.splice(toIndex, 0, sourceItem);
        return this._array;
    }

    /**
     * 交换两个数组项的位置
     *
     * @param {*} sourceIndex 源Item的index
     * @param {*} targetIndex 目标Item的index
     * @return {Array} 操作后的数组
     */
    swap = (sourceIndex, targetIndex) => {
        return [this._array[sourceIndex], this._array[targetIndex]] = [this._array[targetIndex], this._array[sourceIndex]];
    }

    //获取数组
    getArray() {
        return this.cloneDeep(this._array);
    }

    //更新数组
    update(array) {
        this._array = array;
        return this.getArray();
    }
}
export default ArrayUtil;